<template>
    <div class="page clinic-list">

        <list-skeleton v-if="loading" style="margin-bottom: 100vh"></list-skeleton>

        <div v-if="topic.news.length > 0" class="clinic-list-section">

            <div style="padding:15px 15px 15px 15px; box-sizing:border-box">
                <img @click="goBytx()" :src="topic.cover_img" width="100%" alt="">
            </div>

            <div class="clinic-list-section-box" style="margin-top: 15px" v-for="(item,i) in topic.news" :key="item.id">
                <div @click="go_detail(item)" class="article-list-section">
                    <van-row class="article-list-section-box">
                        <van-col span="8">
                            <van-image
                                fit="cover"
                                class="article-list-content-img"
                                :src="item.cover_img"
                                width="100%"
                                height="74"
                            />
                            <div class="article-list-section-box-zl" v-if="item.type == 2">
                                <img src="/static/two/icon_list_tag_subject_text.svg" alt="">
                            </div>
                        </van-col>
                        <van-col span="16" class="article-list-content">
                            <div class="article-list-title">{{item.title.length > 26 ? item.title.substr(0,26)+'...' : item.title}}</div>
                            <div class="article-list-content-detail">
                                <div v-if="item.type == 2">已更新{{item.current_count}}篇 | 共{{item.total_count}}篇</div>
                                <div v-else>{{item.created_at}}<span style="margin-left: 8px">{{item.view_count}}人阅读</span></div>
                            </div>
                        </van-col>
                    </van-row>
                    <div class="clear"></div>
                </div>
                <van-divider v-if="i < list.length-1" />
            </div>
        </div>
    </div>
</template>
<script>
    import Interface from "@/util/interface"
    import listSkeleton from "@/skeleton/listSkeleton"
    export default {
        name: 'course-list',
        components :{
            'list-skeleton' : listSkeleton
        },
        data() {
            return {
                value: "",
                active: "",
                category_id :0,
                category_index:0,
                category_child_id:0,
                banners: [],
                categories: [],
                categories_child:[],
                recommend:[],
                list:[],
                loading:true,
                topic:{},

                nav_active:0,
            }
        },
        methods: {
            fetchTopic() {
                Interface.getData('get', Interface.topic.detail + this.$route.query.topic_id).then((res) => {
                    this.topic = res.data
                })
            },
            fetch(scene) {
                if (scene === 'detail') {
                    Interface.getData('get', Interface.topic.detail + this.id).then((res) => {
                        this.topic = res.data

                        let title = ""
                        if(this.topic.title == ""){
                            title = "靶向专委会"
                        }else{
                            title = this.topic.title
                        }

                        Interface.getShareInfo(this, title, this.topic.cover_img, "点击查看详情")

                        this.loading = false
                    })
                }
            },
            go_detail(item){
	        if (item.content_type != 1){
			window.location.href = item.target_url
			return
		}
                this.$router.push({
                    name: 'meeting-news-detail',
                    params: {
                        id: item.id
                    }
                })
            }
        },
        async created() {
            this.id = this.$route.params.id
            await this.fetch('detail')
            sessionStorage.removeItem("search_data")
        },
    }
</script>
<style lang="scss">
    @import "./index";
</style>



// WEBPACK FOOTER //
// src/views/topic/topic-news-list/index.vue